import {ReferenceListItemFragment} from '#apollo/schema';
import {Text} from '#component/base';
import {anchorNames} from '#component/page/HealthFactorAssessment/HealthFactorAssessment.util';
import {ReferenceList} from '#component/partial/ReferenceList';

import * as css from './HealthFactorReferences.css';

export const HealthFactorReferences = ({references}: {references: ReferenceListItemFragment[]}) => {
  return (
    <div className={css.root} id={anchorNames.references}>
      <div className={css.info}>
        <Text variant="label" color="orange">
          References
        </Text>
        <Text variant="heading2" as="h2" color="burgundy">
          Learn More
        </Text>
      </div>
      <ReferenceList
        className={css.references}
        paddings={[css.innerPadding]}
        references={references}
        widths={['100%']}
      />
    </div>
  );
};
